import React from 'react';
import { TouchableWithoutFeedback, GestureResponderEvent } from 'react-native';
import { Box } from '@styleseat/ui';
import { BrandColor } from '@styleseat/brand';
import { BasicHeartIcon } from '../../../../ui/Icons';
import { clickable } from '../../../../../styles';

type BookmarkIconProps = {
  bookmarked: boolean;
  onClick: () => void;
  showReferralUI?: boolean;
};

const BookmarkIcon: React.FCWithChildren<BookmarkIconProps> = ({
  bookmarked,
  onClick,
  showReferralUI = false,
}) => {
  const handlePress = (event: GestureResponderEvent) => {
    event.preventDefault();
    onClick();
  };

  if (showReferralUI) {
    return (
      <TouchableWithoutFeedback onPress={handlePress}>
        <Box
          testID="bookmark-icon"
          padding={12}
          borderStyle="solid"
          borderRadius={4}
          showBoxShadow
          style={clickable}
        >
          <BasicHeartIcon
            width={24}
            height={24}
            fillColor={bookmarked ? BrandColor.Red : BrandColor.WhiteWash}
            outlineColor={BrandColor.Red}
          />
        </Box>
      </TouchableWithoutFeedback>
    );
  }

  return (
    <TouchableWithoutFeedback onPress={handlePress}>
      <Box testID="bookmark-icon" style={clickable}>
        <BasicHeartIcon
          width={24}
          height={24}
          fillColor={bookmarked ? BrandColor.Red : BrandColor.WhiteWash}
          outlineColor={bookmarked ? BrandColor.Red : BrandColor.Metal}
        />
      </Box>
    </TouchableWithoutFeedback>
  );
};

export default BookmarkIcon;
